module.exports = __webpack_public_path__ + "img/telespazio-logo.9629d092.png";